import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";

/**
 * AuthCallback — handles the Emergent OAuth return.
 * URL contains hash like #session_id=XXXX after Google sign-in.
 *
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH.
 */
export default function AuthCallback() {
  const navigate = useNavigate();
  const { exchangeEmergentSession } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/connexion", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);

    (async () => {
      try {
        await exchangeEmergentSession(sessionId);
        // Clean URL and go to dashboard
        window.history.replaceState({}, "", "/mon-carnet");
        navigate("/mon-carnet", { replace: true });
      } catch {
        navigate("/connexion", { replace: true, state: { error: "google" } });
      }
    })();
  }, [exchangeEmergentSession, navigate]);

  return (
    <main data-testid="auth-callback" className="bg-[#FBF8EF] min-h-screen flex flex-col items-center justify-center gap-6">
      <Loader2 size={28} strokeWidth={1.2} className="animate-spin text-[#5C4033]" />
      <p className="text-[10px] tracking-[0.32em] uppercase text-[#5C4033]">— Connexion en cours</p>
    </main>
  );
}
